/*
 *###############################################################################
 *Module Name                   : ProductGroup.js                               #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Friday, September 10th 2021, 1:39:43 pm       #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
import React, { useState, useEffect } from "react"
import { Row, Col, Button } from "reactstrap"
import Switch from "react-switch"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import { Numeric, DecimalValidation, Text } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPLoadingAlert from 'framework/widgets/DPLoadingAlert'
import ReactPaginate from 'react-paginate';
import DPDropDown from "framework/components/DPDropDown"
import {
  getCustomStrings
} from "./ProductController"



const Offsymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      No
    </div>
  )
}

const OnSymbol = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      Yes
    </div>
  )
}

const ProductInventoryContent = React.memo(({ DataRow, Disabled, Show, SetData, AddNew, menuCode, handleClearStatus, blActive, refreshSIH, showBatch, showVarient }) => {
  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("Please Wait...")
  const [searchString, setSearchString] = useState("")
  const [searchByLocation, setSearchByLocation] = useState(true)
  const [placeholder, setPlaceholder] = useState("Search by Location Code")
  const [currentPage, setCurrentPage] = useState(1)
  const [searchElement, setElement] = useState("code")
  const [searchCondition, setSearchCondition] = useState("graterthan")
  const [searchAmount, setSearchAmount] = useState('')
  const [sihElement, setSihElement] = useState("stockHand")
  const [sitPlaceHolder, setSitPlaceHolder] = useState("Search by Stock In Hand")
  const [toggleDropdown, setToggleDropdown] = useState(false)
  const [mainLocations, setMainLocations] = useState([])
  const [customStrings, setCustomStrings] = useState([])
  const [sortedCustomStrings, setSortedCustomStrings] = useState([])

  /**********End Loading Alert */

  useEffect(() => {
    setSearchString("")
    setPlaceholder("Search by Location Code")
    setSearchByLocation(true)
    setCurrentPage(1)
    setElement("code")
    setSearchCondition("graterthan")
    setSihElement("stockHand")
    setSitPlaceHolder("Search by Stock In Hand")
    setSearchAmount("")
  }, [handleClearStatus])



  // cahnge object values where key is equal to the given value
  function changeObjectValue(value, id, element) {
    var DataSet = [...DataRow]
    const objectIndex = DataRow.findIndex(obj => obj.id === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    DataSet[objectIndex] = newObject
    SetData(DataSet)
  }

  useEffect(async () => {
    var groupedItems = await groupBy(DataRow, 'mainCode')

    var customStrings = await getCustomStrings()

    var sortedData = await groupByCustomString(customStrings)

    const result = Object.keys(groupedItems).map(key => {
      return { value: key, label: groupedItems[key].join('') };
    });

    const Customresult = Object.keys(sortedData).map(key => {
      return { value: sortedData[key], label: key };
    });

    const CustomresultForDropdown = Object.keys(sortedData).map(key => {
      return { value: key, label: key };
    });

    setCustomStrings(CustomresultForDropdown)
    setSortedCustomStrings(Customresult)// custom filterd strings for custom string search
    setMainLocations(result)

  }, [])

  //group by function for main locations
  async function groupBy(objectArray) {
    return objectArray.reduce(function (acc, obj) {
      var key = obj["mainCode"];
      if (obj["mainCode"] == obj["code"]) {
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj.name); //inside array 
      }
      return acc;
    }, {});
  }


  //group by function for custom strings
  async function groupByCustomString(objectArray) {
    return objectArray.reduce(function (acc, obj) {
      var key = obj["label"];

      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj.value); //inside array there are multiple locations related to the custom string

      return acc;
    }, {});
  }

  //filter arracy accoding to the search sting
  const newDataTable = DataRow.filter((value) => {
    if (searchElement != "customString") {
      return value[searchElement].toLowerCase().includes(searchString.toLowerCase())
    } else {
      if (searchString != "") {
        var customLocations = sortedCustomStrings.filter((value) => {
          return value.label.includes(searchString)
        })
        if (customLocations.length > 0) {
          return customLocations[0].value.includes(value.code)
        }
      } else {
        return value;
      }
    }
  })

  const conditonFilterItems = newDataTable.filter((value) => {
    if (searchAmount != "") {
      if (searchCondition == "graterthan") {
        return parseFloat(value[sihElement]) > parseFloat(searchAmount)
      } else if (searchCondition == "lessthan") {
        return parseFloat(value[sihElement]) < parseFloat(searchAmount)
      } else if (searchCondition == "equal") {
        return parseFloat(value[sihElement]) == parseFloat(searchAmount)
      } else if (searchCondition == "greaterthanequal") {
        return parseFloat(value[sihElement]) >= parseFloat(searchAmount)
      } else if (searchCondition == "lessthanequal") {
        return parseFloat(value[sihElement]) <= parseFloat(searchAmount)
      } else if (searchCondition == "notequal") {
        return parseFloat(value[sihElement]) != parseFloat(searchAmount)
      }
    } else {
      return value
    }
  })



  const [postsPerPage, setPostsPerPage] = useState(10)
  const [pageLimit, setPageLimit] = useState([10, 25, 50])

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = conditonFilterItems.slice(indexOfFirstPost, indexOfLastPost)

  // Change page

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };



  return (
    <React.Fragment>
      <Row>
        <DPLoadingAlert
          confirm_both={loadingAlert}
          title={loadingAlertTitle}
        />
      </Row>
      <Row >
        <Col>
          <div className="col-8">
            <div className="form-group">
              <div className="input-group">
                <div class="btn-group-sm" role="group" aria-label="Button group with nested dropdown">
                  <button id="btnGroupDrop1" type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    style={{ background: '#B4B8BD' }}
                    onClick={() => {
                      setToggleDropdown(!toggleDropdown)
                    }}
                  >
                    <i className="mdi mdi-arrow-down-thick"></i>
                  </button>
                  {toggleDropdown ? <ul className={`dropdown form-control-sm open p-0 border-1 `} style={{ border: "solid #ccc", position: 'absolute', zIndex: 10, background: '#FFFFFF' }}>
                    <li
                      className="dropdown"
                      style={{ paddingLeft: 5, margin: '5px', listStyleType: 'none', fontWeight: "inherit", fontSize: "12px", fontFamily: "inherit", cursor: "pointer" }}
                      onClick={() => {
                        setElement("code")
                        setPlaceholder("Search By Location Code")
                        setToggleDropdown(false)
                        setSearchString("")
                      }}
                    >Location Code</li>

                    <li
                      className="dropdown"
                      style={{ paddingLeft: 5, margin: '5px', listStyleType: 'none', fontWeight: "inherit", fontSize: "12px", fontFamily: "inherit", cursor: "pointer" }}
                      onClick={() => {
                        setElement("name")
                        setPlaceholder("Search By Location Description")
                        setToggleDropdown(false)
                        setSearchString("")
                      }}
                    >Location Description</li>

                    <li
                      className="dropdown"
                      style={{ paddingLeft: 5, margin: '5px', listStyleType: 'none', fontWeight: "inherit", fontSize: "12px", fontFamily: "inherit", cursor: "pointer" }}
                      onClick={() => {
                        setElement("description")
                        setPlaceholder("Search By Product Description")
                        setToggleDropdown(false)
                        setSearchString("")
                      }}
                    >Product Description</li>

                    <li className="dropdown"
                      style={{ paddingLeft: 5, margin: '5px', listStyleType: 'none', fontWeight: "inherit", fontSize: "12px", fontFamily: "inherit", cursor: "pointer" }}
                      onClick={() => {
                        setElement("mainCode")
                        setToggleDropdown(false)
                        setSearchString("")
                      }}
                    >Main Location Code</li>

                    <li className="dropdown"
                      style={{ paddingLeft: 5, margin: '5px', listStyleType: 'none', fontWeight: "inherit", fontSize: "12px", fontFamily: "inherit", cursor: "pointer" }}
                      onClick={() => {
                        setElement("customString")
                        setToggleDropdown(false)
                        setSearchString("")
                      }}
                    >Custom Location Group</li>

                  </ul> : null}
                </div>

                {searchElement != "mainCode" && searchElement != "customString" ?
                  <input id="SearchBar" type="text" className="form-control" value={searchString} placeholder={placeholder} aria-label="Username" aria-describedby="basic-addon1" style={{ height: '28px', width: '300px' }} onChange={e => {
                    // searchHandler(e.target.value)
                    setSearchString(e.target.value)
                    setCurrentPage(1)
                    // setPage(0)
                  }} />
                  : <DPDropDown
                    width={"300px"}
                    rowClass={"mb-12-sm"}
                    labelHide={true}
                    optionGroup={searchElement == "mainCode" ? mainLocations : customStrings}
                    selectedGroup={searchString}
                    padding={"p-0"}
                    onChange={(e) => {
                      setSearchString(e.value)
                      setCurrentPage(1)
                    }}
                  />}
              </div>
            </div>
          </div>
          <Button className="mt-2" onClick={refreshSIH} size="sm"> Refresh SIH</Button>
        </Col>

        <Col style={{ textAlign: 'end' }}>
          <div style={{ display: 'inline-block' }} className="form-group">
            <div className="input-group">
              <div className="input-group-prepend">
                <span style={{ height: '28px' }} className="input-group-text" id="basic-addon1"><i className="mdi mdi-magnify"></i></span>
              </div>
              <input id="SearchBar" type="number" className="form-control" value={searchAmount} placeholder={sitPlaceHolder} aria-label="Username" aria-describedby="basic-addon1" style={{ height: '28px' }} onChange={e => {
                // searchHandler(e.target.value)
                setSearchAmount(e.target.value)
                setCurrentPage(1)
                // setPage(0)
              }} />
            </div>
          </div>

          <div style={{ display: 'inline-block' }}>
            <div style={{ display: 'inline-block' }} className="form-group">
              <span title="Equal" className="input-group-text" id="basic-addon1" style={{ height: '28px', background: searchCondition == "equal" ? 'cadetblue' : '#EFF2F7', cursor: 'pointer' }} onClick={(e) => {
                setSearchCondition("equal")
                setCurrentPage(1)
              }}><i className="mdi mdi-equal"></i></span>
            </div>
            <div style={{ display: 'inline-block' }} className="form-group">
              <span title="Graterthan" className="input-group-text" id="basic-addon1" style={{ height: '28px', background: searchCondition == "graterthan" ? 'cadetblue' : '#EFF2F7', cursor: 'pointer' }} onClick={(e) => {
                setSearchCondition("graterthan")
                setCurrentPage(1)
              }} ><i className="mdi mdi-greater-than"></i></span>
            </div>
            <div style={{ display: 'inline-block' }} className="form-group">
              <span title="Lessthan" className="input-group-text" id="basic-addon1" style={{ height: '28px', background: searchCondition == "lessthan" ? 'cadetblue' : '#EFF2F7', cursor: 'pointer' }} onClick={(e) => {
                setSearchCondition("lessthan")
                setCurrentPage(1)
              }}><i className="mdi mdi-less-than"></i></span>
            </div>
            <div style={{ display: 'inline-block' }} className="form-group">
              <span title="Lessthan Or Equal" className="input-group-text" id="basic-addon1" style={{ height: '28px', background: searchCondition == "lessthanequal" ? 'cadetblue' : '#EFF2F7', cursor: 'pointer' }} onClick={(e) => {
                setSearchCondition("lessthanequal")
                setCurrentPage(1)
              }}><i className="mdi mdi-less-than-or-equal"></i></span>
            </div>
            <div style={{ display: 'inline-block' }} className="form-group">
              <span title="Graterthan Or Equal" className="input-group-text" id="basic-addon1" style={{ height: '28px', background: searchCondition == "greaterthanequal" ? 'cadetblue' : '#EFF2F7', cursor: 'pointer' }} onClick={(e) => {
                setSearchCondition("greaterthanequal")
                setCurrentPage(1)
              }}><i className="mdi mdi-greater-than-or-equal"></i></span>
            </div>
          </div>

        </Col>
      </Row>
      <Row>
        <SampleTable
          DataTables={currentPosts}
          indexOfFirstPost={indexOfFirstPost}
          Disabled={Disabled}
          handleCostChanges={changeObjectValue}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setPlaceholder={setPlaceholder}
          setSearchByLocation={setSearchByLocation}
          setElement={setElement}
          setSearchString={setSearchString}
          setSihElement={setSihElement}
          setSitPlaceHolder={setSitPlaceHolder}
          setoInventory={SetData}
          blActive={blActive}
          AddNew={AddNew}
          showBatch={showBatch}
          showVarient={showVarient}
          AllRows={DataRow}
        />
      </Row>
      <Row className="mt-1">
        <Col md="1">
          <select
            className="form-control form-control-sm"
            value={postsPerPage}
            onChange={(e) => {
              setPostsPerPage(e.target.value)
              setCurrentPage(1)
            }}
          >
            {pageLimit.map((page, index) => {
              return <option key={index} value={page}>{page}</option>
            }
            )}
          </select>
        </Col>
        <Col md="11">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(conditonFilterItems.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-center pagination-sm'}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
})
export default ProductInventoryContent

const TableRow = ({ FormRow, Key, Disabled, addnew, handleCostChanges, blActive, showBatch, showVarient }) => {

  return (
    <tr key={Key}>
      <td style={{ width: "100px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          textType="text"
          disabled={true}
          id={"txtLocCode" + Key}
          value={FormRow.code}
        ></DPTextBoxforgrid>
      </td>
      <td style={{ width: "100px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          textType="text"
          disabled={true}
          id={"txtLocdesc" + Key}
          value={FormRow.name}

        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "400px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          textType="text"
          textAlign={"right"}
          disabled={true}
          id={"stockCode" + Key}
          value={FormRow.stockCode}
          titleEnable={true}
        ></DPTextBoxforgrid>
      </td>

      {showBatch ? null : <td style={{ width: "400px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          textType="text"
          textAlign={"right"}
          disabled={true}
          id={"txtProDesc" + Key}
          value={FormRow.description}
          titleEnable={true}
        ></DPTextBoxforgrid>
      </td>}


      <td style={{ width: "200px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          textType="text"
          textAlign={"right"}
          disabled={true}
          id={"manualBatch" + Key}
          value={FormRow?.manualBatch ?? ""}
          titleEnable={true}
        ></DPTextBoxforgrid>
      </td>


      <td style={{ width: "60px", margin: "auto" }}>
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          onColor="#626ed4"
          height={23}
          handleDiameter={15}
          onChange={(e) => {

            handleCostChanges(e, FormRow.id, "state")

          }}
          checked={FormRow.state}
          id={"posActive" + Key}
          disabled={Disabled ? true : blActive ? false : true}
        />
      </td>

      <td style={{ width: "60px", margin: "auto" }}>
        <Switch
          uncheckedIcon={<Offsymbol />}
          checkedIcon={<OnSymbol />}
          onColor="#626ed4"
          height={23}
          handleDiameter={15}
          onChange={(e) => {

            handleCostChanges(e, FormRow.id, "stateBO")

          }}
          checked={FormRow.stateBO}
          id={"boActive" + Key}
          disabled={Disabled ? true : blActive ? false : true}
        />
      </td>

      <td style={{ margin: "auto" }}>
        <DPTextBoxforgrid
          textAlign="right"
          textType={"date"}
          id={"expiryDate" + Key}
          value={FormRow.expiryDate != "" ? FormRow.expiryDate.slice(0, 10) : ""}
          disabled={true}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "100px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          defaultValue="0.0"
          textAlign="right"
          id={"txtCostPrice" + Key}
          value={FormRow.costPrice == "NaN" ? "0.0" : FormRow.costPrice}
          width="70px"
          disabled={addnew ? false : true}
          onChange={e => {
            let CostPrice = Numeric(e.target, 8, 2, false)
            if (CostPrice == "") {
              handleCostChanges("0.0", FormRow.id, "costPrice")
            }
            else {
              handleCostChanges(CostPrice, FormRow.id, "costPrice")
            }

          }}
          onBlur={e => {
            let CostPrice = DecimalValidation(e.target.value, 0, true, 2)
            if (CostPrice == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "costPrice")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "costPrice")
            }
          }}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "100px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          defaultValue="0.0"
          textAlign="right"
          maxLength="10"
          id={"txtAVGCost" + Key}
          value={FormRow.avgCost == "NaN" ? "0.0" : FormRow.avgCost}
          width="70px"
          disabled={addnew ? Disabled : true}
          onChange={e => {
            let AVGCost = Numeric(e.target, 8, 2, false)
            if (AVGCost == "") {
              handleCostChanges("0.0", FormRow.id, "avgCost")
            }
            else {
              handleCostChanges(AVGCost, FormRow.id, "avgCost")

            }
          }}
          onBlur={e => {
            let AVGCost = DecimalValidation(e.target.value, 0, true, 2)
            if (AVGCost == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "avgCost")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "avgCost")
            }
          }}
        ></DPTextBoxforgrid>
      </td>


      <td style={{ width: "100px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          defaultValue="0.0"
          textAlign="right"
          maxLength="10"
          id={"txtSellingPrice" + Key}
          value={FormRow.sellingPrice == "NaN" ? "0.0" : FormRow.sellingPrice}
          width="70px"
          // disabled={Disabled}
          disabled={addnew ? false : true}
          onChange={e => {
            let Selling = Numeric(e.target, 8, 2, false)
            if (Selling == "") {
              handleCostChanges("0.0", FormRow.id, "sellingPrice")
            }
            else {
              handleCostChanges(Selling, FormRow.id, "sellingPrice")
            }
          }}
          onBlur={e => {
            let Selling = DecimalValidation(e.target.value, 0, true, 2)
            if (Selling == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "sellingPrice")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "sellingPrice")
            }
          }}
        ></DPTextBoxforgrid>
      </td>


      <td style={{ width: "70px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          defaultValue="0.0"
          maxLength="10"
          textAlign="right"
          width="70px"
          disabled={Disabled}
          id={"txtReorderLevel" + Key}
          value={FormRow.reorderLevel}
          onChange={e => {

            let ReorderLevel = Numeric(e.target, 8, 2, false)
            if (ReorderLevel == "") {
              handleCostChanges("0.0", FormRow.id, "reorderLevel")
            }
            else {
              handleCostChanges(ReorderLevel, FormRow.id, "reorderLevel")
            }
          }}
          onBlur={e => {
            let ReorderLevel = DecimalValidation(e.target.value, 0, true, 2)
            if (ReorderLevel == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "reorderLevel")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "reorderLevel")
            }
          }}
        ></DPTextBoxforgrid>
      </td>


      <td style={{ width: "70px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          defaultValue="0.0"
          maxLength="10"
          width="70px"
          textAlign="right"
          disabled={Disabled}
          id={"txtReorderQTY" + Key}
          value={FormRow.reorderQTY}
          onChange={e => {
            let Reorder = Numeric(e.target, 8, 2, false)
            if (Reorder == "") {
              handleCostChanges("0.0", FormRow.id, "reorderQTY")
            }
            else {
              handleCostChanges(Reorder, FormRow.id, "reorderQTY")

            }
          }}
          onBlur={e => {
            let Reorder = DecimalValidation(e.target.value, 0, true, 2)
            if (Reorder == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "reorderQTY")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "reorderQTY")
            }
          }}
        ></DPTextBoxforgrid>
      </td>


      <td style={{ width: "70px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          width="70px"
          textAlign="right"
          id={"txtMaximumQTY" + Key}
          value={FormRow.maximumQTY}
          disabled={Disabled}
          onChange={e => {
            let Maxqty = Numeric(e.target, 8, 2, false)
            if (Maxqty == "") {
              handleCostChanges("0.0", FormRow.id, "maximumQTY")
            }
            else {
              handleCostChanges(Maxqty, FormRow.id, "maximumQTY")
            }

          }}
          onBlur={e => {
            let Maxqty = DecimalValidation(e.target.value, 0, true, 2)
            if (Maxqty == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "maximumQTY")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "maximumQTY")
            }
          }}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "70px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="20"
          textAlign="right"
          width="70px"
          disabled={Disabled}
          id={"txtGondolaQTY" + Key}
          value={FormRow.gondolaQTY}
          onChange={e => {
            let Gondol = Numeric(e.target, 8, 2, false)
            if (Gondol == "") {
              handleCostChanges("0.0", FormRow.id, "gondolaQTY")
            }
            else {
              handleCostChanges(Gondol, FormRow.id, "gondolaQTY")
            }
          }}
          onBlur={e => {
            let Gondol = DecimalValidation(e.target.value, 0, true, 2)
            if (Gondol == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "gondolaQTY")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "gondolaQTY")
            }
          }}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "70px", margin: "auto" }}>

        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          width="70px"
          maxLength="20"
          disabled={Disabled}
          id={"txtBackShelf" + Key}
          value={FormRow.backShelf}
          onChange={e => {
            handleCostChanges(e.target.value, FormRow.id, "backShelf")
          }}
          onBlur={e => {
            let Gondol = Text(e.target, 8, 2, false)
            if (Gondol == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "backShelf")
            }
            else {
              handleCostChanges(e.target.value, FormRow.id, "backShelf")
            }
          }}
        ></DPTextBoxforgrid>
      </td>


      <td style={{ width: "70px", margin: "auto" }}>

        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          width="70px"
          maxLength="20"
          disabled={Disabled}
          id={"txtFrontShelf" + Key}
          value={FormRow.frontShelf}
          onChange={e => {
            handleCostChanges(e.target.value, FormRow.id, "frontShelf")
          }}
          onBlur={e => {
            let Gondol = Text(e.target, 8, 2, false)
            if (Gondol == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "frontShelf")
            }
            else {
              handleCostChanges(e.target.value, FormRow.id, "frontShelf")
            }
          }}
        ></DPTextBoxforgrid>
      </td>


      <td style={{ width: "70px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          defaultValue="0.0"
          textAlign="right"
          width="70px"
          maxLength="10"
          disabled={addnew ? Disabled : true}
          id={"txtOpeningStock" + Key}
          value={FormRow.openingStock}
          onChange={e => {
            let valOS = Numeric(e.target, 8, 2, false)
            if (valOS == "") {
              handleCostChanges("0.0", FormRow.id, "openingStock")
            }
            else {
              handleCostChanges(valOS, FormRow.id, "openingStock")
            }
          }}
          onBlur={e => {
            let valOS = DecimalValidation(e.target.value, 0, true, 2)
            if (valOS == "") {
              handleCostChanges(parseFloat(0).toFixed(2), FormRow.id, "openingStock")
            }
            else {
              handleCostChanges(DecimalValidation(e.target.value, 0, true, 2), FormRow.id, "openingStock")
            }
          }}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "70px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          defaultValue="0.0"
          width="70px"
          textAlign="right"
          disabled={true}
          id={"txtStockHand" + Key}
          value={FormRow.stockHand}
        ></DPTextBoxforgrid>
      </td>

      <td style={{ width: "70px", margin: "auto" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          maxLength="10"
          defaultValue="0.0"
          width="70px"
          textAlign="right"
          disabled={true}
          id={"availablestock" + Key}
          value={FormRow.availablestock}
        ></DPTextBoxforgrid>
      </td>

    </tr>
  )
}

const TableWithPagination = ({ DataTables,
  handleCostChanges, table, Disable, currentPage,
  setCurrentPage, setPlaceholder, setSearchByLocation,
  setElement, setSearchString, setSihElement, setSitPlaceHolder,
  setoInventory, blActive, AddNew, showBatch, showVarient }) => {


  useEffect(() => {
    setCurrentPage(1)
  }, [table])

  const [postsPerPage] = useState(10)

  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataTables.slice(indexOfFirstPost, indexOfLastPost)

  // Change page

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };

  const headerStyle = {
    textAlign: "center",
    width: "100px",
    height: "auto",
    cursor: 'pointer',
  };

  return (
    <React.Fragment>

      <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
        <table style={{ fontSize: "12px", width: '100%', borderCollapse: 'collapse' }}>
          <thead className="table-light">
            <tr>
              <th onClick={() => {
                setPlaceholder("Search By Location Code")
                setSearchByLocation(true)
                setElement("code")
                setSearchString("")
              }} style={{ cursor: 'pointer' }}>Location Code</th>
              <th onClick={() => {
                setPlaceholder("Search By Location Description")
                setSearchByLocation(true)
                setElement("name")
                setSearchString("")
              }} style={{ cursor: 'pointer' }}>Location Description</th>
              <th onClick={() => {
                setPlaceholder("Search By Stock Code")
                setSearchByLocation(false)
                setElement("stockCode")
                setSearchString("")
              }} style={{ cursor: 'pointer' }}>Stock Code</th>
              {!showBatch && (
                <th onClick={() => {
                  setPlaceholder("Search By Product Description")
                  setSearchByLocation(false)
                  setElement("description")
                  setSearchString("")
                }} style={{ cursor: 'pointer' }}>Product Description</th>
              )}
              <th>Manual Batch</th>
              <th style={headerStyle} onClick={() => {

                if (!Disable) {
                  if (blActive) {
                    const allEnabled = DataTables.every((item) => item.state == 1)
                    if (allEnabled) {
                      const filterList = DataTables.map((item) => {
                        item.state = 0
                        return item
                      })
                      setoInventory(filterList)
                    } else {
                      const filterList = DataTables.map((item) => {
                        item.state = 1
                        return item
                      })
                      setoInventory(filterList)
                    }
                  }
                }
              }}>Active for POS</th>
              <th style={headerStyle} onClick={() => {
                if (!Disable) {
                  if (blActive) {
                    const allEnabled = DataTables.every((item) => item.stateBO == 1)
                    if (allEnabled) {
                      const filterList = DataTables.map((item) => {
                        item.stateBO = 0
                        return item
                      })
                      setoInventory(filterList)
                    } else {
                      const filterList = DataTables.map((item) => {
                        item.stateBO = 1
                        return item
                      })
                      setoInventory(filterList)
                    }
                  }
                }
              }}>Active for Backoffice</th>
              <th style={headerStyle}>Expiry Date</th>
              <th style={headerStyle}>Cost Price</th>
              <th style={headerStyle}>Average Cost</th>
              <th style={headerStyle}>Selling Price</th>
              <th style={headerStyle}>Re-order Level</th>
              <th style={headerStyle}>Re-order QTY</th>
              <th style={headerStyle}>Maximum QTY</th>
              <th style={headerStyle}>Gondola Qty</th>
              <th style={headerStyle}>Back Shelf</th>
              <th style={headerStyle}>Front Shelf</th>
              <th style={headerStyle}>Opening Stock</th>
              <th style={headerStyle} onClick={() => setSitPlaceHolder("Search By Stock In Hand")}>Stock in Hand</th>
              <th style={headerStyle} onClick={() => setSitPlaceHolder("Search By Available Stock")}>Available Stock</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.map((values, index) => (
              <TableRow
                key={index}
                FormRow={values}
                Disabled={Disable}
                handleCostChanges={handleCostChanges}
                blActive={blActive}
                addnew={AddNew}
                showBatch={showBatch}
                showVarient={showVarient}
              />
            ))}
          </tbody>
        </table>
      </div>


      <Row className="mt-1">
        <Col md="12">
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            pageCount={Math.ceil(DataTables.length / postsPerPage)}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            forcePage={currentPage - 1}
            renderOnZeroPageCount={null}
            activeClassName={'active'}
            activeLinkClassName={'page-link'}
            containerClassName={'pagination justify-content-center pagination-sm'}
          />
        </Col>
      </Row>

    </React.Fragment>
  )
}



const SampleTable = ({ DataTables, indexOfFirstPost,
  handleCostChanges, table, Disabled, currentPage,
  setCurrentPage, setPlaceholder, setSearchByLocation,
  setElement, setSearchString, setSihElement, setSitPlaceHolder,
  setoInventory, blActive, AddNew, showBatch, showVarient, AllRows }) => {


  return (
    <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
      <table style={{ fontSize: "12px", width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
        <thead className="table-light">
          <tr>
            {/* <th style={{ width: '150px' }}>Location Code</th>
            <th style={{ width: '200px' }}>Location Description</th>
            <th style={{ width: '100px' }}>Stock Code</th>
            <th style={{ width: '200px' }}>Product Description</th>
            <th style={{ width: '100px' }}>Manual Batch</th>
            <th style={{ width: '100px' }}>Active for POS</th>
            <th style={{ width: '100px' }}>Active for Backoffice</th> */}
            <th style={{ cursor: 'pointer', width: '50px' }}>#</th>
            <th onClick={() => {
              setPlaceholder("Search By Location Code")
              setSearchByLocation(true)
              setElement("code")
              setSearchString("")
            }} style={{ cursor: 'pointer', width: '100px' }}>Location Code</th>
            <th onClick={() => {
              setPlaceholder("Search By Location Description")
              setSearchByLocation(true)
              setElement("name")
              setSearchString("")
            }} style={{ cursor: 'pointer', width: '100px' }}>Location Name</th>
            <th onClick={() => {
              setPlaceholder("Search By Stock Code")
              setSearchByLocation(false)
              setElement("stockCode")
              setSearchString("")
            }} style={{ cursor: 'pointer', width: '150px' }}>Stock Code</th>
            <th onClick={() => {
              setPlaceholder("Search By Product Description")
              setSearchByLocation(false)
              setElement("description")
              setSearchString("")
            }} style={{ cursor: 'pointer', width: '200px' }}>Product Description</th>
            <th style={{ width: '100px' }}>Manual Batch</th>
            <th style={{ width: '100px' }}>Opening Stock</th>
            <th style={{ width: '100px' }}>Stock in Hand</th>
            <th style={{ width: '100px' }}>Available Stock</th>
            <th onClick={() => {

              if (!Disabled) {
                if (blActive) {
                  const allEnabled = AllRows.every((item) => item.state == 1)
                  if (allEnabled) {
                    const filterList = AllRows.map((item) => {
                      item.state = 0
                      return item
                    })
                    setoInventory(filterList)
                  } else {
                    const filterList = AllRows.map((item) => {
                      item.state = 1
                      return item
                    })
                    setoInventory(filterList)
                  }
                }
              }
            }} style={{ width: '70px' }}>Active for POS</th>
            <th onClick={() => {
              if (!Disabled) {
                if (blActive) {
                  const allEnabled = AllRows.every((item) => item.stateBO == 1)
                  if (allEnabled) {
                    const filterList = AllRows.map((item) => {
                      item.stateBO = 0
                      return item
                    })
                    setoInventory(filterList)
                  } else {
                    const filterList = AllRows.map((item) => {
                      item.stateBO = 1
                      return item
                    })
                    setoInventory(filterList)
                  }
                }
              }
            }} style={{ width: '70px' }}>Active for Backoffice</th>
            <th style={{ width: '150px' }}>Expiry Date</th>
            <th style={{ width: '100px' }}>Cost Price</th>
            <th style={{ width: '100px' }}>Average Cost</th>
            <th style={{ width: '100px' }}>Selling Price</th>
            <th style={{ width: '100px' }}>Re-order Level</th>
            <th style={{ width: '100px' }}>Re-order QTY</th>
            <th style={{ width: '100px' }}>Maximum QTY</th>
            <th style={{ width: '100px' }}>Gondola Qty</th>
            <th style={{ width: '100px' }}>Back Shelf</th>
            <th style={{ width: '100px' }}>Front Shelf</th>
            <th style={{ width: '100px' }}>Buffer QTY</th>

          </tr>
        </thead>
        <tbody>
          {DataTables.map((row, index) => (
            <tr key={index}>
              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="lineNo"
                  maxLength="10"
                  textType="text"
                  disabled={true}
                  value={indexOfFirstPost + index + 1}
                ></DPTextBoxforgrid></td>
              <td >
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  textType="text"
                  disabled={true}
                  value={row.code}
                ></DPTextBoxforgrid>
              </td>
              <td >
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  textType="text"
                  disabled={true}
                  value={row.name}

                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  textType="text"
                  textAlign={"right"}
                  disabled={true}
                  value={row.stockCode}
                  titleEnable={true}
                ></DPTextBoxforgrid>
              </td>

              <td >
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  textType="text"
                  textAlign={"right"}
                  disabled={true}
                  value={row.description}
                  titleEnable={true}
                ></DPTextBoxforgrid>
              </td>

              <td >
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  textType="text"
                  textAlign={"right"}
                  disabled={true}
                  value={row?.manualBatch ?? ""}
                  titleEnable={true}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  defaultValue="0.0"
                  textAlign="right"
                  width="70px"
                  maxLength="10"
                  disabled={AddNew ? Disabled : true}
                  value={row.openingStock}
                  onChange={e => {
                    let valOS = Numeric(e.target, 18, 4, false)
                    if (valOS == "") {
                      handleCostChanges("0.0", row.id, "openingStock")
                    }
                    else {
                      handleCostChanges(valOS, row.id, "openingStock")
                    }
                  }}
                  onBlur={e => {
                    let valOS = DecimalValidation(e.target.value, 0, true, 4)
                    if (valOS == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "openingStock")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "openingStock")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  defaultValue="0.0"
                  width="70px"
                  textAlign="right"
                  disabled={true}
                  value={row.stockHand}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  defaultValue="0.0"
                  width="70px"
                  textAlign="right"
                  disabled={true}
                  value={row.availablestock}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  onColor="#626ed4"
                  height={23}
                  handleDiameter={15}
                  onChange={(e) => {

                    handleCostChanges(e, row.id, "state")

                  }}
                  checked={row.state}
                  disabled={Disabled ? true : blActive ? false : true}
                />
              </td>

              <td >
                <Switch
                  uncheckedIcon={<Offsymbol />}
                  checkedIcon={<OnSymbol />}
                  onColor="#626ed4"
                  height={23}
                  handleDiameter={15}
                  onChange={(e) => {

                    handleCostChanges(e, row.id, "stateBO")

                  }}
                  checked={row.stateBO}
                  disabled={Disabled ? true : blActive ? false : true}
                />
              </td>

              <td >
                <DPTextBoxforgrid
                  textAlign="right"
                  textType={"date"}
                  value={row.expiryDate != "" ? row.expiryDate.slice(0, 10) : ""}
                  disabled={true}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  defaultValue="0.0"
                  textAlign="right"
                  value={row.costPrice == "NaN" ? "0.0" : row.costPrice}
                  width="70px"
                  disabled={AddNew ? false : true}
                  onChange={e => {
                    let CostPrice = Numeric(e.target, 18, 4, false)
                    if (CostPrice == "") {

                      handleCostChanges("0.0", row.id, "costPrice")
                    }
                    else {
                      handleCostChanges(CostPrice, row.id, "costPrice")
                    }

                  }}
                  onBlur={e => {
                    let CostPrice = DecimalValidation(e.target.value, 0, true, 4)
                    if (CostPrice == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "costPrice")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "costPrice")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  defaultValue="0.0"
                  textAlign="right"
                  maxLength="10"
                  value={row.avgCost == "NaN" ? "0.0" : row.avgCost}
                  width="70px"
                  disabled={AddNew ? Disabled : true}
                  onChange={e => {
                    let AVGCost = Numeric(e.target, 18, 4, false)
                    if (AVGCost == "") {
                      handleCostChanges("0.0", row.id, "avgCost")
                    }
                    else {
                      handleCostChanges(AVGCost, row.id, "avgCost")

                    }
                  }}
                  onBlur={e => {
                    let AVGCost = DecimalValidation(e.target.value, 0, true, 4)
                    if (AVGCost == "") {
                      handleCostChanges(parseFloat(0).toFixed(2), row.id, "avgCost")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "avgCost")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>


              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  defaultValue="0.0"
                  textAlign="right"
                  maxLength="10"
                  value={row.sellingPrice == "NaN" ? "0.0" : row.sellingPrice}
                  width="70px"
                  // disabled={Disabled}
                  disabled={AddNew ? false : true}
                  onChange={e => {
                    let Selling = Numeric(e.target, 18, 4, false)
                    if (Selling == "") {
                      handleCostChanges("0.0", row.id, "sellingPrice")
                    }
                    else {
                      handleCostChanges(Selling, row.id, "sellingPrice")
                    }
                  }}
                  onBlur={e => {
                    let Selling = DecimalValidation(e.target.value, 0, true, 4)
                    if (Selling == "") {
                      handleCostChanges(parseFloat(0).toFixed(2), row.id, "sellingPrice")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "sellingPrice")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>


              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  defaultValue="0.0"
                  maxLength="10"
                  textAlign="right"
                  width="70px"
                  disabled={Disabled}
                  value={row.reorderLevel}
                  onChange={e => {

                    let ReorderLevel = Numeric(e.target, 18, 4, false)
                    if (ReorderLevel == "") {
                      handleCostChanges("0.0", row.id, "reorderLevel")
                    }
                    else {
                      handleCostChanges(ReorderLevel, row.id, "reorderLevel")
                    }
                  }}
                  onBlur={e => {
                    let ReorderLevel = DecimalValidation(e.target.value, 0, true, 4)
                    if (ReorderLevel == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "reorderLevel")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "reorderLevel")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>


              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  defaultValue="0.0"
                  maxLength="10"
                  width="70px"
                  textAlign="right"
                  disabled={Disabled}
                  value={row.reorderQTY}
                  onChange={e => {
                    let Reorder = Numeric(e.target, 18, 4, false)
                    if (Reorder == "") {
                      handleCostChanges("0.0", row.id, "reorderQTY")
                    }
                    else {
                      handleCostChanges(Reorder, row.id, "reorderQTY")

                    }
                  }}
                  onBlur={e => {
                    let Reorder = DecimalValidation(e.target.value, 0, true, 4)
                    if (Reorder == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "reorderQTY")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "reorderQTY")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>


              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="10"
                  width="70px"
                  textAlign="right"
                  value={row.maximumQTY}
                  disabled={Disabled}
                  onChange={e => {
                    let Maxqty = Numeric(e.target, 18, 4, false)
                    if (Maxqty == "") {
                      handleCostChanges("0.0", row.id, "maximumQTY")
                    }
                    else {
                      handleCostChanges(Maxqty, row.id, "maximumQTY")
                    }

                  }}
                  onBlur={e => {
                    let Maxqty = DecimalValidation(e.target.value, 0, true, 4)
                    if (Maxqty == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "maximumQTY")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "maximumQTY")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  maxLength="20"
                  textAlign="right"
                  width="70px"
                  disabled={Disabled}
                  value={row.gondolaQTY}
                  onChange={e => {
                    let Gondol = Numeric(e.target, 18, 4, false)
                    if (Gondol == "") {
                      handleCostChanges("0.0", row.id, "gondolaQTY")
                    }
                    else {
                      handleCostChanges(Gondol, row.id, "gondolaQTY")
                    }
                  }}
                  onBlur={e => {
                    let Gondol = DecimalValidation(e.target.value, 0, true, 4)
                    if (Gondol == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "gondolaQTY")
                    }
                    else {
                      handleCostChanges(DecimalValidation(e.target.value, 0, true, 4), row.id, "gondolaQTY")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>

              <td>

                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  width="70px"
                  maxLength="20"
                  disabled={Disabled}
                  value={row.backShelf}
                  onChange={e => {
                    handleCostChanges(e.target.value, row.id, "backShelf")
                  }}
                  onBlur={e => {
                    let Gondol = Text(e.target, 18, 4, false)
                    if (Gondol == "") {
                      handleCostChanges(parseFloat(0).toFixed(2), row.id, "backShelf")
                    }
                    else {
                      handleCostChanges(e.target.value, row.id, "backShelf")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>


              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  width="70px"
                  maxLength="20"
                  disabled={Disabled}
                  value={row.frontShelf}
                  onChange={e => {
                    handleCostChanges(e.target.value, row.id, "frontShelf")
                  }}
                  onBlur={e => {
                    let Gondol = Text(e.target, 18, 2, false)
                    if (Gondol == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "frontShelf")
                    }
                    else {
                      handleCostChanges(e.target.value, row.id, "frontShelf")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>

              <td>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  width="70px"
                  maxLength="20"
                  textAlign={"right"}
                  disabled={Disabled}
                  value={row.bufferQTY}
                  onChange={e => {
                    handleCostChanges(e.target.value, row.id, "bufferQTY")
                  }}
                  onBlur={e => {
                     let Gondol = DecimalValidation(e.target.value, 0, true, 4)
                    if (Gondol == "") {
                      handleCostChanges(parseFloat(0).toFixed(4), row.id, "bufferQTY")
                    }
                    else {
                      handleCostChanges(e.target.value, row.id, "bufferQTY")
                    }
                  }}
                ></DPTextBoxforgrid>
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

